/* globals AmCharts */
import _ from 'lodash';
import '@dsisolutions/amcharts/amcharts';
import '@dsisolutions/amcharts/themes/material';

// Define default options in attempt to keep charts consistent and dry

// https://docs.amcharts.com/3/javascriptcharts/AmChart
const BaseChartOptions = {
  theme: 'material',
  fontFamily: 'inherit',
  numberFormatter: {
    precision: 2,
  },
  valueField: 'value',
  titleField: 'label',
  labelRadius: 12,
};

// https://docs.amcharts.com/3/javascriptcharts/AmPieChart
const PieChartOptions = _.defaults(
  {
    type: 'pie',
    angle: 15, // degree angle for 3D view
    depth3D: 20, // thickness of 3D pie
    innerRadius: '40%', // creates the donut
    startDuration: 0, // disable animations
  },
  BaseChartOptions
);

// https://docs.amcharts.com/3/javascriptcharts/AmSerialChart
const SerialChartOptions = _.defaults(
  {
    type: 'serial',
    categoryField: 'category',
    chartCursor: {
      categoryBalloonEnabled: false, // balloon on x-axis
      cursorAlpha: 0,
      zoomable: false, // disabled on widgets
      bulletsEnabled: true,
    },
    categoryAxis: {
      gridPosition: 'start',
      labelRotation: 45,
      labelsEnabled: true,
    },
  },
  BaseChartOptions
);

// distinction between bar and serial is when the graphs.type is set to column
// eg graphs: [{ type: column }]
const BarChartOptions = _.defaults(
  {
    depth3D: 10, // default to 3D
    angle: 30,
    rotate: false, // default to columns
  },
  SerialChartOptions
);

const LineGraphOptions = {
  balloonText: '[[title]] [[category]]: $[[value]]',
  lineThickness: 2,
  bullet: 'round',
  bulletSize: 5,
  bulletBorderAlpha: 1,
  bulletColor: '#FFFFFF',
  useLineColorForBulletBorder: true,
  type: 'line',
};

const BarGraphOptions = {
  balloonText: '[[category]]: [[value]]',
  fillAlphas: 1,
  lineAlpha: 0.2,
  type: 'column',
  lineColor: 'black',
};

const makePieChart = (elemId, options) => {
  return AmCharts.makeChart(elemId, _.defaultsDeep(options, PieChartOptions));
};

const makeSerialChart = (elemId, options) => {
  return AmCharts.makeChart(elemId, _.defaultsDeep(options, SerialChartOptions));
};

const makeBarChart = (elemId, options) => {
  return AmCharts.makeChart(elemId, _.defaultsDeep(options, BarChartOptions));
};

const getBarGraph = options => {
  return _.defaultsDeep(options, BarGraphOptions);
};

const getLineGraph = options => {
  return _.defaultsDeep(options, LineGraphOptions);
};

const getColors = (theme = 'material') => {
  return AmCharts.themes[theme].AmSlicedChart.colors.slice(0);
};

const autoColor = (theme = 'material') => {
  let colors = getColors(theme);

  return () => {
    if (!colors.length) {
      colors = getColors();
    }

    return colors.shift();
  };
};

export default {
  autoColor,
  getBarGraph,
  getColors,
  getLineGraph,
  makePieChart,
  makeSerialChart,
  makeBarChart,
};
